<template>
    <div class="top-bar-group" @mouseenter="toggleShowChildren" @mouseleave="toggleShowChildren">
        <div class="top-bar-group-header" >
            <slot name="header"/>
        </div>
        <div class="top-bar-group-children" v-if="showChildren">
            <slot/>
        </div>

    </div>
</template>

<script>
    export default {
        name: "TopBarGroup",
        data: function () {
            return {
                showChildren: false
            }
        },
        methods: {
            toggleShowChildren() {
                this.showChildren = !this.showChildren;
            }
        }
    }
</script>

<style lang="scss" scoped>
@import "../../styles/global";

.top-bar-group-header {
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: center;
    padding: 8px 15px 8px 15px;
}

.top-bar-group {
    user-select: none;
    cursor: default;
    color: inherit;
    display: inline-flex;
    justify-items: center;
    align-items: center;
    height: 100%;
    z-index: 9999;
}

.top-bar-group:hover {
    background-color: darken($navigationGray, 5);
}

.top-bar-group-children {
    position: absolute;
    background-color: darken($navigationGray, 3);
    top: 32px;
}

</style>